<template>
  <div class="mx-12">
    <img :src="`${block.image}?${random_value}`" class="w-full">

    <pre v-if="debug">
      {{ block }}
    </pre>
  </div>
</template>

<script>
export default {
  props: {
    block: {
      type: Object,
      require: true
    }
  },
  data() {
    return {
      debug: false
    }
  },
  computed: {
    random_value: () => Math.random()
  }
}
</script>